import { render, staticRenderFns } from "./NoCommodities.vue?vue&type=template&id=44becc16&"
import script from "./NoCommodities.vue?vue&type=script&lang=js&"
export * from "./NoCommodities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports